export const unitPriceList = [
    {
        id: 0,
        value: '指定なし',
    },
    {
        id: 1,
        value: '10万'
    },
    {
        id: 2,
        value: '20万'
    },
    {
        id: 3,
        value: '30万'
    },
    {
        id: 4,
        value: '40万'
    },
    {
        id: 5,
        value: '50万'
    },
    {
        id: 6,
        value: '60万'
    },
    {
        id: 7,
        value: '70万'
    },
    {
        id: 8,
        value: '80万'
    },
    {
        id: 9,
        value: '90万'
    },
    {
        id: 10,
        value: '100万'
    },
    {
        id: 15,
        value: '150万'
    },
    {
        id: 20,
        value: '200万'
    },
    {
        id: 25,
        value: '250万'
    },
    {
        id: 30,
        value: '300万'
    },
    {
        id: 35,
        value: '350万'
    },
    {
        id: 40,
        value: '400万'
    },
    {
        id: 45,
        value: '450万'
    },
    {
        id: 50,
        value: '500万'
    }
]